module.exports = __webpack_public_path__ + "img/or.dd29c912.png";